import { render } from "./GatewayTransactions.vue?vue&type=template&id=1a4e4cf8&scoped=true&ts=true"
import script from "./GatewayTransactions.vue?vue&type=script&lang=ts"
export * from "./GatewayTransactions.vue?vue&type=script&lang=ts"

import "./GatewayTransactions.vue?vue&type=style&index=0&id=1a4e4cf8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a4e4cf8"]])

export default __exports__